import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActionConfig } from '../../../interfaces/action-config';
import { ColumnConfig } from '../../../interfaces/column-config';
import { ParentHeaderTable } from '../../../interfaces/parent-header-table-config';
import { TableChangeData } from '../../../interfaces/table-chage-data';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-dynamic-table',
  standalone: true,
  imports:[CommonModule,NgSelectModule,NgbDropdownModule,TranslateModule,NgbPaginationModule,FormsModule],
  templateUrl: './dynamic-table.component.html',
  styleUrl: './dynamic-table.component.scss'
})
export class DynamicTableComponent {
  @Input() hasSelectAll:boolean = false;
  @Input() hideActionIfNotExist?: string;
  @Input() columns: Array<ColumnConfig> = [];
  @Input() dataset: { isSelected?: boolean, [t: string]: any }[] = [];
  @Input() actions: Array<ActionConfig> = [];
  @Input() options: Array<ActionConfig> = [];
  @Input() parentHeader: Array<ParentHeaderTable> = [];
  @Input() isPaginated: boolean = true;
  @Input() isSortable: boolean = true;
  @Input() hideHeader: boolean = false;
  @Input() paginationData: { currentPage: number, totalPages: number, totalRecord?: number } = { currentPage: 0, totalPages: 0 };
  @Input() isSelectable: boolean = false;
  @Input() isSelectAllPages: boolean = false;
  @Output() onSelectChange: EventEmitter<any> = new EventEmitter();
  @Output() onSelectAllPages: EventEmitter<any> = new EventEmitter();
  @Output() onTableFromChange: EventEmitter<any> = new EventEmitter();
  @Output() onTableChange: EventEmitter<TableChangeData> = new EventEmitter();
  @Output() onActionClick: EventEmitter<{ name: string, data: any }> = new EventEmitter();
  @Input() hasTotalTemplate: boolean = false;
  @Input() hideShowingEntries: boolean = false;
  @Input() setCrntPageToFirst:boolean = false;
  @Input() appendTo: string = 'body';
  key = "";
  reverse: boolean = true;
  tableData: TableChangeData = {
    pageIndex: 1,
    limit: 10
  };
  public page = 1;
  @Input() public pageSize = 10;
  public optionsSizes = [5, 10, 20, 50];

  constructor(
    public translateService: TranslateService,
  ) {
    translateService.use(this.translateService.currentLang)
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.translateService.use(this.translateService.currentLang);
    if(changes['setCrntPageToFirst']) {
      this.page = 1;
    }
  }


  
  sort(col: ColumnConfig) {
    if (col.sortable) {
      if (this.key != col.field)
        this.reverse = true;

      this.key = col.field;
      this.reverse = !this.reverse;
      this.tableData.col = this.key;
      this.tableData.sortType = this.reverse ? "ASC" : "DESC";
      this.onTableChanged();
    }
  }

  toggleSwitchChange(event:any,data:any) {
  this.onTableFromChange.emit({event,data})
  }

  onTableChanged() {
    this.onTableChange.emit(this.tableData)
  }

  onActionClicked(name: string, data: any) {
    this.onActionClick.emit({ name, data })
  }

  loadPage(pageIndex: any) {
    this.tableData.pageIndex = pageIndex;
    this.onTableChanged();
  }

  limitChange(limit: any) {
    if ((this.tableData.pageIndex * limit) > (this.paginationData.totalPages * this.tableData.limit)) {
      this.tableData.pageIndex = 1;
      this.tableData.limit = limit;
    }
    this.tableData.limit = limit;
    this.onTableChanged();
  }

  isNumber(str: string): boolean {
    return /^[0-9\.]+$/.test(str);
  }

  onSelectChanged(event: any, index: any, data: any) {
    this.dataset[index].isSelected = event.target.checked
    this.onSelectChange.emit(this.dataset[index])
  }

  onSelectAll(event: any) {
    const isChecked = event.target.checked;
  
    if (this.isSelectAllPages) {
      this.onSelectAllPages.emit(isChecked);
    }
  
    for (const item of this.dataset) {
      if (item['isSelectable'] !== undefined && !item['isSelectable']) {
        continue;
      }
      item.isSelected = isChecked;
      this.onSelectChange.emit(item);
    }
  }
  dataSetAllSelected(): boolean {
    return this.dataset.every(d => d.isSelected == true)
  }
  
  dataSetNotAllSelected(): boolean {
    return this.dataset.some(d => d.isSelected == true)
  }

  hasDropdownActions(actions: ActionConfig[], data: any): boolean {
    for (const item of actions) {
      if (!(item.isDisable && item.isDisable(data))) {
        return false;
      }
    }
    return true;
  }

}

